<div class="approve-document-reason-container">
  <form [formGroup]="approveDocumentForm" (ngSubmit)="submit()">
    <div class="form-control">
      <label for="notes">Enter the text for the approval of this document.</label>
      <textarea (keyup)="notesTyped($event)" name="notes" id="notes" formControlName="notes"
        [maxlength]="1000" required></textarea>
      <div class="typed-characters-container" style="text-align: end">
        {{ typedCharacteres }} / {{ maxCharacteresAllowed }}
      </div>
    </div>

    <div class="actions">
      <button (click)="cancel()" type="button" id="btn-cancel">
        <span class="material-icons"> cancel</span> <span>Cancel</span>
      </button>
      <button type="submit" id="btn-save" [disabled]="!isSaveButtonEnabled" (click)="saveReason()">
        <span class="material-icons"> save</span> <span>Save</span>
      </button>
    </div>
  </form>
</div>